import { DirectUpload } from "activestorage"

const DIRECT_UPLOADS_URL = "/rails/active_storage/direct_uploads"

// Sends one file straight to storage and resolves with its signed id, so the
// file never crosses the app server or Cloudflare's 100 MB request cap.
export function directUpload(file) {
  return new Promise((resolve, reject) => {
    new DirectUpload(file, DIRECT_UPLOADS_URL).create((error, blob) => {
      if (error) reject(new Error("We couldn't upload that file. Please try again."))
      else resolve(blob.signed_id)
    })
  })
}
